module.exports = __webpack_public_path__ + "img/IMG_0713.b465befa.jpg";